var isCapacitor = function () {
    try {
        return window.Capacitor && (window.Capacitor.platform === "android" || window.Capacitor.platform === "ios") || window.forceCapacitor;
    }
    catch (error) {
        return false;
    }
};
export default isCapacitor;
//# sourceMappingURL=isCapacitor.js.map